import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hook-one',
  templateUrl: './hook-one.component.html',
  styleUrls: ['./hook-one.component.scss']
})
export class HookOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
